import { Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import sp1 from '../../images/PulaPlus.png'
import sp2 from '../../images/gradPula.png'
import sp3 from '../../images/ZTKIZ.png'
import sp4 from '../../images/ZTKP.png'

function Sponsors() {

    
    const useStyles = makeStyles({
        root:{
            marginTop:"50px",
            margin:"0 auto",
            width:"80%"
            
        },
        image:{
            margin: "0 auto",
            display: "block",
            marginTop: "20px",
            maxWidth: "100%"
        }, 
        cont:{
            width: "100%"
        }
    });

    const classes = useStyles();  


    return (
        <div className={classes.root}>
             <Typography align="center" variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold"}}y
             > 
             SPONZORI
            </Typography>
            <Grid container
            direction="row"
            alignContent="center"
            width="100%"
            textAlign="center"
            justifyContent="center"
            >

            <Grid item lg={6} md={12} sm={12} className={classes.cont}>
                <img src={sp1} className={classes.image}/>
            </Grid>

            <Grid item lg={6} md={12} sm={12} className={classes.cont}>
            <img src={sp2} className={classes.image}/>
            </Grid>

            <Grid item lg={6} md={12} sm={12} className={classes.cont}>
            <img src={sp3} className={classes.image}/>
            </Grid>

            <Grid item lg={6} md={12} sm={12} className={classes.cont}>
            <img src={sp4} className={classes.image}/>
            </Grid>

            </Grid>
            
        </div>
    )
}

export default Sponsors
